import { useCallback, useEffect, useState } from 'react';
import { workflowApi } from '../../services/api';
import { WorkflowTemplate } from '../../types';

/**
 * Workflow templates from the executor, loaded the first time `enabled` turns
 * on (Advanced settings opened, or a workflow is switched on for the form) and
 * kept for the life of the builder.
 */
export const useWorkflowTemplates = (tenantId: string, enabled: boolean) => {
  const [templates, setTemplates] = useState<WorkflowTemplate[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    setError(false);
    workflowApi
      .getTemplates(tenantId)
      .then(setTemplates)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [tenantId]);

  useEffect(() => {
    if (enabled && templates === null && !loading && !error) load();
  }, [enabled, templates, loading, error, load]);

  return { templates, loading, error, reload: load };
};
